module.exports = __webpack_public_path__ + "86f9d7429d6e0cd07427f472e1f94d1f.svg";